import React, { Component } from "react";
import AdmissionApi from "../../Services/AdmissionApi";
import { StickyShare } from '../ShareButton'

import HeroImg from '../../assets/images/hero-img.svg'
import CareerCounselingImg from '../../assets/images/career-counseling.jpg'
import AdmnAssistanceImg from '../../assets/images/admn-assistance.jpg'
import GlobalLogoImg from '../../assets/images/clients/global-logo.jpg'
import PaulLogoImg from '../../assets/images/clients/paul-logo.jpg'
import PsbbLogoImg from '../../assets/images/clients/psbb-logo.jpg'
import SagarLogoImg from '../../assets/images/clients/sagar-logo.jpg'
import ShriramLogoImg from '../../assets/images/clients/shriram-logo.jpg'
import SosLogoImg from '../../assets/images/clients/sos-logo.jpg'

import "./style.css";

import Header from "../Header";
import Footer from "../Footer";


class App extends Component {
  constructor() {
    super();
    this.state = { userType: 0, type: 0 };

    this.admissionsService = new AdmissionApi();
  }

  componentDidMount() {
    let data = localStorage.getItem("type");
    this.setState({ type: data });
  }

  render() {
    let isLogin = localStorage.getItem("isLogin");
    const type = isLogin;
    return (
      <div className="App">
        <Header type={type} logo={this.state.logo} />

        <div className="hero">
          <div className="container">
            <div className="row">
              <div className="order-2 text-center text-lg-left col-sm-12 col-lg-6">
                <h2 className="hero__heading">Make sure you do not miss an important deadline for college admissions in India</h2>
                <p>Stay on top of your college admissions with alerts on entrance exams announcements, college admission notices and much more.</p>
                <a href="/contact" className="admn-cta-btn">Get Personalized Guidance</a>
              </div>
              <div className="order-1 order-lg-3 mb-3 mb-lg-0 col-sm-12 col-lg-6 d-flex align-items-center">
                <figure className="hero__img">
                  <img src={HeroImg} alt="hero banner" />
                </figure>
              </div>
            </div>
          </div>
        </div>

        <div className="features">
          <div className="container">
            <div className="row text-center text-lg-left">
              <div className="col-sm-12 col-md-6 col-lg-3">
                <i className="admn-icon icon-finance-067 u-line-icon-pro"></i>
                <p>NOTIFYi enables students keep track of all admission and scholarship related notifications
                  put out by universities and colleges pan India.</p>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-3">
                <i className="admn-icon icon-education-103 u-line-icon-pro"></i>
                <p>NOTIFYi gets students to know of different courses they can do which they were not aware
                  of earlier.</p>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-3">
                <i className="admn-icon icon-education-124 u-line-icon-pro"></i>
                <p>NOTIFYi helps students identify colleges which they may not have heard about before.</p>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-3">
                <i className="admn-icon icon-education-127 u-line-icon-pro"></i>
                <p>NOTIFYi helps students shortlist the admission and scholarship application they want to
                  pursue.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="admn-description">
          <div className="container">
            <h2 className="admn-description-heading">Find the perfectly matched course and college in India</h2>
            <p>Admizzionz Campuz helps students get on top of their college admission process by <strong>assuring them of	a college admission</strong> that best matches their profile in terms of
              potential, performance and preference by implementing a smart shortlisting
              strategy which is totally customised for each student.</p>
            <a href="/contact" className="admn-cta-btn mt-3">Get Personalized Guidance</a>
          </div>
        </div>

        <div className="hero text-center text-lg-left">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-lg-6 order-2">
                <h2 className="hero__heading showcase__heading">Career Counselling</h2>
                <p className="text-justify">Admizzionz Campuz&#174; makes use of <strong>automated online tools</strong> based on established vocational psychology findings, to help students achieve <strong>clarity in their career choices</strong>. Professional career counselling during <strong>private sessions</strong> with the students and their parents helps explore and assess their academic and extracurricular performance and potential, and <strong>provides career direction for future success</strong>.</p>
                <a href="/vision" className="admn-cta-btn">Read More</a>
              </div>
              <div className="col-sm-12 col-lg-6 d-flex align-items-center order-1 order-lg-3 mb-3 mb-lg-0">
                <figure className="hero__img showcase-img">
                  <img src={CareerCounselingImg} alt="hero banner" />
                </figure>
              </div>
            </div>
          </div>
        </div>

        <div className="hero pt-5 text-center text-lg-left">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-lg-6 d-flex align-items-center mb-3 mb-lg-0">
                <figure className="hero__img showcase-img">
                  <img src={AdmnAssistanceImg} alt="hero banner" />
                </figure>
              </div>
              <div className="col-sm-12 col-lg-6">
                <h2 className="hero__heading showcase__heading">College Admission Assistance</h2>
                <p className="text-justify">Admizzionz Campuz&#174; provides counselling to school and college students in <strong>all the steps</strong> required for an <strong>assured college admission</strong> in India or abroad <strong>irrespective of the marks obtained</strong>. What’s more with its comprehensive database of courses and colleges in India, the students are <strong>spoilt for choice</strong> when it comes down to selecting courses and colleges.</p>
                <a href="/vision" className="admn-cta-btn">Read More</a>
              </div>
            </div>
          </div>
        </div>

        <div className="clients mt-5 mt-lg-0">
          <div className="container">
            <h2 className="clients__heading">Our Clients</h2>
            <div className="row">
              <div className="col-sm-12 col-md-4 col-lg-2">
                <figure>
                  <img src={GlobalLogoImg} alt="client logo" />
                </figure>
              </div>
              <div className="col-sm-12 col-md-4 col-lg-2">
                <figure>
                  <img src={PaulLogoImg} alt="client logo" />
                </figure>
              </div>
              <div className="col-sm-12 col-md-4 col-lg-2">
                <figure>
                  <img src={PsbbLogoImg} alt="client logo" />
                </figure>
              </div>
              <div className="col-sm-12 col-md-4 col-lg-2">
                <figure>
                  <img src={SagarLogoImg} alt="client logo" />
                </figure>
              </div>
              <div className="col-sm-12 col-md-4 col-lg-2">
                <figure>
                  <img src={ShriramLogoImg} alt="client logo" />
                </figure>
              </div>
              <div className="col-sm-12 col-md-4 col-lg-2">
                <figure>
                  <img src={SosLogoImg} alt="client logo" />
                </figure>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <StickyShare />
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App/index.js
 **/